import { Tab } from "bootstrap";

window.addEventListener("load", () => {
  const heroTabButtons = document.querySelectorAll("#heroTab button");
  const heroImageTabs = document.querySelectorAll(
    "#heroImageTabContent .tab-pane"
  );

  if (!heroTabButtons.length || !heroImageTabs.length) return;

  let i = 0;
  let autoRotate;

  // --- Sync image tabs with content tabs ---
  heroTabButtons.forEach((button) => {
    button.addEventListener("shown.bs.tab", (e) => {
      let target = e.target.getAttribute("data-bs-target");

      heroImageTabs.forEach((tab) => tab.classList.remove("active", "show"));

      const newImageTab = document.querySelector(
        `#heroImageTabContent ${target}`
      );
      if (newImageTab) {
        newImageTab.classList.add("active");
        requestAnimationFrame(() => newImageTab.classList.add("show"));
      }
    });
  });

  // --- Rotate tabs ---
  function rotateTabs() {
    const tabTrigger = new Tab(heroTabButtons[i]);
    tabTrigger.show();
    i = (i + 1) % heroTabButtons.length;
  }

  // --- Start auto-rotation with reset option ---
  function startAutoRotate() {
    stopAutoRotate();
    autoRotate = setInterval(rotateTabs, 10000); // 4s per switch
  }

  function stopAutoRotate() {
    if (autoRotate) clearInterval(autoRotate);
  }

  // Start when page loads
  startAutoRotate();

  // --- Reset timer only on manual tab switch ---
  heroTabButtons.forEach((button, idx) => {
    button.addEventListener("click", () => {
      i = idx + 1; // next rotation continues after clicked tab
      startAutoRotate(); // resets timer
    });
  });
});
